<template>
  <mu-dialog
    :open = 'showDialog'
    @close = 'close'
  >
    <mu-toast v-if="toast" :message="errorMsg"/>
    <div
      style = '
      '
    >
      <mu-radio
        name = 'trainScope'
        label = '所有可选训练'
        nativeValue = 'all-trains'
        v-model = 'trainScope'
      />
      <mu-radio
        name = 'trainScope'
        label = '训练方案内训练'
        nativeValue = 'planned-trains'
        v-model = 'trainScope'
      />
      <mu-radio
        name = 'trainScope'
        label = '系统推荐训练'
        nativeValue = 'recommended-trains'
        v-model = 'trainScope'
      />
    </div>
    <trainMenu 
      ref="trainmenu" 
      :trainCategories='trainCategories'
      @category-path-updated = 'onTrainCategoryChoose'
    />
    <div
      style = '
        overflow-y: auto;
        min-height: 50vh;
        max-height: 50vh;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: stretch;
      '
    >
        <div 
          style="
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-grow: 1;
          "
          v-if="showAddPlanRoute"
        >
          当前没有训练方案，<span class="" @click="toTrainPlan(caseId)"><a style="text-decoration:underline;cursor:pointer;">添加方案</a></span>
        </div>
      <card-list
        v-else
        :listItems = 'currentTrainCategory ? currentTrainCategory.games : []'
        :itemComponent = 'trainCard'
        @list-item-clicked = 'onTrainClicked'
     />
    </div>
      <mu-raised-button 
        label="取消" 
        @click="cancelhandler" 
        style="color:#999;" 
        slot="actions" 
        />
      <mu-raised-button 
        style="width:160px;margin-left:20px;"
        slot="actions" 
        :disabled="Object.values(selectedGames).length === 0"  
        @click="goTrain" 
        primary 
      >
        <span style="color:#fff;">
        {{`去训练(已选${Object.values(selectedGames).length}个)`}}
        </span>
      </mu-raised-button>
      <mu-flat-button 
        :label="trainCounts" 
        :class="[{'red':timeWarn},{'orange':!timeWarn}]" 
        slot="actions" 
        primary 
      />
  </mu-dialog>
</template>
<script>
  import Vue             from 'vue'
  import store           from '../../../store/index.js'
  import {removeByValue} from '../../../assets/js/common.js'
  import bz_utils        from '../../../bz/utils'
  import CardList        from '../../../foundation/ui/controls/card-list';
  import trainMenu       from '../../common/trainMenu.vue'
  import TrainListItem   from '../../bz/train-card';

  export default ({
    store,
    // 获取父级数据
    props: {
      caseId:{
        type: String,
        default: function(){
          return this.$route.params.id
        }
      },
    },
    data() {
      return {
        address: GLOBAL.cognition,
        showLoading: false,
        showTimeTrain: false,
        checkItem: [],
        checkedID: [],
        oneGrade: '',
        twoGrade: '',
        // 用于显示各标签游戏内容
        trainShowList: [],
        trainList: [],
        trainDailyList:[],
        trainPlanList:[],
        selectTrain:'daily',
        noContent:false,
        activeTab: 2,
        subject:[
          {value:"all",text:"显示全部"},
          {value:"plan",text:"显示训练方案"},
          {value:"daily",text:"显示今日训练"}
        ], //为select组件传递option值
        selectContent:{
          value:"daily",
          text:"显示今日训练"
        },
        selectNum: '',// 选中的游戏个数
        toGO: true,
        trainUrl: '',
        time: 0,  // 每次训练的时长（分钟）
        errorMsg: '',
        toast: false,
        /**
         *
         *  新数据
         *
         */
        games: [],
        trainScope: 'all-trains',
        showDialog: false,
        trainCategories: bz_utils.buildTrainCategoryTree(),
        currentTrainCategory: null,
        trains: null,
        trainCard: TrainListItem,
        selectedGames: {},
        gamesInDailyTrains: {},
        gamesInPlan: {},
      }
    },
    watch: {
      trainScope: function()
      {
        if (this.trainScope === 'all-trains')
        {
          this.trainCategories.resetGames(this.trains);
        }
        else if (this.trainScope === 'planned-trains')
        {
          this.trainCategories.resetGames(this.trains.filter(x=>x.id in this.gamesInPlan));
        }
        else if (this.trainScope === 'recommended-trains')
        {
          this.trainCategories.resetGames(this.trains.filter(x=>x.id in this.gamesInDailyTrains));
        }
        this.$forceUpdate();
      }
    },
    computed:{
      trainCounts(){
        return "剩余：" + this.$store.state.trainCounts + "次";
      },
      timeWarn(){
        return this.$store.state.trainCounts <= 3;
      },
      showAddPlanRoute()
      {
        return (
          this.trainScope !== 'all-trains' 
          && Object.values(this.gamesInPlan).length === 0
        );
      },
    },
    components:{
      trainMenu,
      'card-list': CardList,
    },
    mounted() {
    },
    methods: {
      // 路由到训练方案
      toTrainPlan (id) {
        this.$router.push({name: 'trainPlan', params: {id: id}});
        this.$emit('close');
      },
      handleTabChange(val){
        this.activeTab = val;
      },
      choose(val) {
        this.selectContent.value = val.value;
        if (val.value == "daily") {
          this.getDaily();
        }else if(val.value == "plan"){
          this.getPlan();
        }else if(val.value == "all"){
          this.fetch();
        }
      },
      // 获取今日训练的游戏列表
      getDaily:function(id){
        this.showLoading = true;
        return Vue.http({
          method: 'GET',
          url:'/api/Train/getDailyTrainingProgram',
          params: {
            'id': this.caseId
          }
        })
        .then((res)=>{
          var listAll = res.data.data.cogn.concat(res.data.data.lan);
          if (listAll.length > 0) { //当今日训练有内容时
            this.trainDailyList = res.data.data.cogn.concat(res.data.data.lan);
            this.trainShowList = this.trainDailyList;
            for(let i=0; i<this.trainShowList.length; i++){
              this.trainShowList[i]['id'] = this.trainShowList[i]['taskId'] || this.trainShowList[i]['id'];
            }
          }else{
            this.noContent = true;
          }
          this.setSelect();
        })
      },
      // 把今日训练列表中的游戏设置为默认选中
      setSelect:function(){
        // 设置临时变量，存储修改默认游戏后切换标签时的选中显示
        let tempList = {};
        if(Object.keys(this.checkItem).length > 0){
          tempList = this.checkItem;
        } else {
          tempList = this.trainDailyList;
        }
        for(let j=0; j<this.trainShowList.length; j++){
          for(let i=0; i<tempList.length; i++){
            if(this.trainShowList[j].id == tempList[i].id){
              this.$set(this.trainShowList[j],"checked",true)
            }
          }
        }
        this.getSelectNum();
      },
      // 获取训练方案的游戏列表
      getPlan:function(id){
        this.showLoading = true;
        return Vue.http({
          method: 'GET',
          url:'api/Train/getManualProgram',
          params: {
            'id': this.caseId
          }
        })
        .then((res)=>{
          var listAll = res.data.data.cogn.concat(res.data.data.lan);
          if (listAll.length > 0) {
            this.noContent = false;
            this.trainPlanList = res.data.data.cogn.concat(res.data.data.lan);
            this.trainShowList = this.trainPlanList;
          }else{
            this.noContent = true;
          }
          this.setSelect();
        })
      },
      fetch: function (id) {
        this.noContent = false;
        this.showLoading = true;
        this.trainList = [];
        var obj = {}; //用来供reduce使用的对象
        if (this.oneGrade >= 0){
          Vue.http({
            method: 'GET',
            url: '/api/Game/getAllGames'
          })
          .then((res) => {
            // 区分2.0的言语训练
            if (this.oneGrade == 11){
              this.trainList = res.data.data.lan;
              this.trainList = this.trainList.concat(res.data.data.rehab_lan);//1.0言语部分追加
            } else if(this.oneGrade == 10) {
              this.trainList = res.data.data.cogn;
            } else if(this.oneGrade == 12) {
              this.trainList = res.data.data.men;
            } else {
              this.trainList = res.data.data.cogn.concat(res.data.data.lan).concat(res.data.data.men);
              this.trainList = this.trainList.concat(res.data.data.rehab_lan);//1.0言语部分追加
            }
            this.trainList = this.trainList.reduce((cur,next) => {
              obj[next.name] ? "" : obj[next.name] = true && cur.push(next);
              return cur;
            },[]);
            // 以下从配置文件中匹配标签
            if(typeof id != 'undefined'){
              var tempList = [];
              for(var x=0; x<this.trainList.length; x++){
                var tempLabel = this.trainList[x].label.split(',');
                for(var y=0; y<tempLabel.length; y++){
                  if (tempLabel[y] == id){
                    tempList.push(this.trainList[x]);
                  }
                }
              }
              this.trainList = tempList;
            }
            this.trainShowList = this.trainList;
            this.setSelect();
          })
        }
      },
      // 设置点击后的选中效果
      selectedItem: function (item, index) {
        this.$set(this.trainShowList[index],"checked",!item.checked);
        this.getSelectNum(item);
      },
      // 获取当前过滤器下已选中的游戏个数
      getSelectNum: function(item){
        this.toGO = true;
        // 如果item没值，说明是默认的；否则是点击操作，则只针对此操作进行处理
        if(!item){
          for(let i=0; i<this.trainShowList.length; i++){
            let hasFlag = false;
            if(this.trainShowList[i].checked){
              for(let j=0; j<this.checkItem.length; j++){
                if(this.checkItem[j].id == this.trainShowList[i].id){
                  hasFlag = true;
                }
              }
              if(!hasFlag){
                this.checkItem.push(this.trainShowList[i]);
                this.checkedID.push(this.trainShowList[i].id);
              }
            }
          }
        } else {
          if(item.checked){
            this.checkItem.push(item);
            this.checkedID.push(item.id);
          } else {
            for(let i=0; i<this.checkItem.length; i++){
              if(this.checkItem[i].id == item.id){
                this.checkItem.splice(i, 1);
                break;
              }
            }
            removeByValue(this.checkedID,item.id);
          }
        }
        var self = this;
        setTimeout(function(){
          let num = self.checkItem.length;
          if(num > 0){self.toGO = false;}
          self.selectNum = "去训练(已选"+num+"个)";
        },0)
        this.showLoading = false;
      },
      traincontentCall:function(p1,p2,p3){
        if(typeof p3 == 'undefined'){
          this.oneGrade = p1;
          this.twoGrade = p2;
          this.fetch();
        } else {
          this.fetch(p3);
        }
      },
      cancelhandler(){
        this.$store.commit('changeCounts');//修改训练次数
        this.$emit("close");
        this.close();
      },
      goTrain(){
        console.log(this.toGO);
        this.$http.post('/api/Train/startTM',{
          patient_uuid: this.caseId,
          checked: Object.keys(this.selectedGames)
        },{emulateJSON: false})
        .then((res)=>{
          console.log(res)
          this.$router.push({path: '/trainTime/',query:{selectTrain:this.checkItem,caseId: this.caseId, time: res.body.left}});
          this.cancelhandler();
        },(req)=>{
          this.showToast(req.data.resultMsg);
        })
        // 在标签打开训练
        // let checked = JSON.stringify(this.checkItem);
        // this.trainUrl = "http://" + window.location.host + "/#/trainTime?selectTrain="+checked+"&caseId="+this.caseId;
        // window.open(this.trainUrl)
        // console.log(JSON.parse(JSON.stringify(this.checkItem)));
      },
      showToast (msg) {
        this.toast = true;
        this.errorMsg = msg;
        if (this.toastTimer) clearTimeout(this.toastTimer)
        this.toastTimer = setTimeout(() => { this.toast = false }, 2000)
      },
      close () {
        // this.dialog = false;
        this.showDialog = false;
      },
      show: function()
      {
        this.resetData();
        let self = this;
        this.getDaily()
        .then(x=>self.getPlan())
        .then(x=>{
          self.showDialog = true;
        });
      },
      resetData: function()
      {
        this.trains = null;
        this.gamesInDailyTrains = {};
        this.gamesInPlan = {};
        this.selectedGames = {};
      },
      onTrainCategoryChoose: function(categoryPath)
      {
        var self = this;
        let cat = categoryPath.slice(-1)[0];
        this.currentTrainCategory = cat;
        if (this.trains === null)
        {
          Vue.http({
            method: 'GET',
            url: '/api/Game/getAllGames',
          }).then(resp=>{
            let selection = self.selectedGames;
            let gamesInDailyTrains = self.gamesInDailyTrains;
            self.trainDailyList.forEach(x=>gamesInDailyTrains[x.id] = x);
            let gamesInPlan = self.gamesInPlan;
            self.trainPlanList.forEach(x=>gamesInPlan[x.id] = x);
            let flat_games = 
              bz_utils.canonicalizeGames(resp.data.data);
            flat_games.forEach(x=>
            {
              Object.defineProperty(x, 'selected', {
                get: function()
                {
                  return (this.id in selection);
                },
                set: function(val)
                {
                  if (true === val)
                  {
                    selection[this.id] = this;
                  }
                  else
                  {
                    delete selection[this.id];
                  }
                },
              });
              if (x.id in gamesInDailyTrains)
              {
                x.selected = true;
              }
            });
            self.trainCategories.resetGames(flat_games);
            self.trains = flat_games;
          })
        }
      },
      onTrainClicked: function(ev)
      {
        let game = ev.itemData;
        if (game.selected)
        {
          game.selected = false;
        }
        else
        {
          game.selected = true;
        }
        ev.item.$forceUpdate();
        this.$forceUpdate();
      },
    },
    beforeDestroy(){
      this.checkItem.forEach(function(item, index){
        item.checked = false;
      });
    }
  })
</script>
<style lang="stylus" scoped>
  @import "../../../assets/css/app.styl"

  .mu-dialog
    max-width 1024px !important
  .plan-content
    min-height 500px
  button#doTrain
    background-color: #ccc;
  .no-content
    position absolute
    left 50%
    top 50%
    transform translateX(-50%)
    font-family: PingFangTC-Semibold;
    font-size: 14px;
    color: #333333;
    font-weight: 600;
  .red
    margin-left 100px
    color red
    font-weight bold
  .orange
    margin-left 100px
    color orange
</style>



// WEBPACK FOOTER //
// timeModalSelect.vue?547d2e79